import { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';

const SERVICE_LINES = [
  { value: 'home_health',  label: 'Home Health' },
  { value: 'flexi_health', label: 'Flexi Health' },
  { value: 'market_health',label: 'Market Health' },
];

const COUNTRIES = [
  'Nigeria',
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda',
  'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan',
  'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize',
  'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil',
  'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi',
  'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic',
  'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo (Brazzaville)',
  'Congo (Kinshasa)', 'Costa Rica', "Côte d'Ivoire", 'Croatia', 'Cuba', 'Cyprus',
  'Czech Republic',
  'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
  'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia',
  'Eswatini', 'Ethiopia',
  'Fiji', 'Finland', 'France',
  'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada',
  'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hungary',
  'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
  'Jamaica', 'Japan', 'Jordan',
  'Kazakhstan', 'Kenya', 'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan',
  'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein',
  'Lithuania', 'Luxembourg',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta',
  'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
  'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar',
  'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger',
  'North Korea', 'North Macedonia', 'Norway',
  'Oman',
  'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay',
  'Peru', 'Philippines', 'Poland', 'Portugal',
  'Qatar',
  'Romania', 'Russia', 'Rwanda',
  'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines',
  'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal',
  'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia',
  'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan',
  'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria',
  'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga',
  'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
  'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States',
  'Uruguay', 'Uzbekistan',
  'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
  'Yemen',
  'Zambia', 'Zimbabwe',
];

export default function AgentSignup() {
  const [form, setForm] = useState({
    full_name: '', email: '', phone: '',
    country: 'Nigeria',
    bank_name: '', bank_code: '', account_number: '', account_name: '',
    sort_code_iban: '',
    service_lines: [],
  });
  const [banks, setBanks] = useState([]);
  const [banksLoading, setBanksLoading] = useState(true);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [submitted, setSubmitted] = useState(false);

  const isNigeria = form.country === 'Nigeria';

  useEffect(() => {
    fetch('https://api.paystack.co/bank?currency=NGN&perPage=100')
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          setBanks(data.data.map(b => ({ name: b.name, code: b.code })));
        }
      })
      .catch(() => {})
      .finally(() => setBanksLoading(false));
  }, []);

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const toggleServiceLine = (val) => {
    setForm(f => ({
      ...f,
      service_lines: f.service_lines.includes(val)
        ? f.service_lines.filter(s => s !== val)
        : [...f.service_lines, val],
    }));
  };

  const validate = () => {
    if (!form.full_name.trim())     return 'Full name is required.';
    if (!form.email.trim() || !form.email.includes('@')) return 'Valid email is required.';
    if (!form.phone.trim())         return 'Phone number is required.';
    if (isNigeria) {
      if (!form.bank_code) return 'Please select your bank.';
      if (!form.account_number.trim())  return 'Account number is required.';
      if (!form.account_name.trim())    return 'Account name is required.';
    } else {
      if (!form.bank_name.trim())       return 'Bank name is required.';
      if (!form.account_number.trim())  return 'Account number is required.';
      if (!form.account_name.trim())    return 'Account holder name is required.';
    }
    if (form.service_lines.length === 0) return 'Please select at least one service line.';
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) { setError(err); return; }
    setError('');
    setLoading(true);
    try {
      const { error } = await supabase
        .from('agents')
        .insert([{
          full_name:      form.full_name.trim(),
          email:          form.email.trim().toLowerCase(),
          phone:          form.phone.trim(),
          country:        form.country,
          bank_name:      form.bank_name,
          bank_code:      isNigeria ? form.bank_code : '',
          account_number: form.account_number.trim(),
          account_name:   form.account_name.trim(),
          sort_code_iban: isNigeria ? '' : form.sort_code_iban.trim(),
          service_lines:  form.service_lines,
          status:         'pending',
        }]);
      if (error) throw error;
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inp = {
    width: '100%', padding: '10px 12px', border: '1px solid #dee2e6',
    borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit',
    outline: 'none', boxSizing: 'border-box',
  };

  const label = (text, required) => (
    <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#555', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
      {text}{required && <span style={{ color: '#dc3545', marginLeft: '2px' }}>*</span>}
    </label>
  );

  const field = (children) => (
    <div style={{ marginBottom: '16px' }}>{children}</div>
  );

  if (submitted) {
    return (
      <div style={{ minHeight: '100vh', background: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div style={{ background: 'white', borderRadius: '12px', padding: '40px', maxWidth: '480px', width: '100%', textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
          <div style={{ width: '56px', height: '56px', background: '#d4edda', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '24px' }}>✓</div>
          <h2 style={{ margin: '0 0 12px', color: '#333', fontSize: '22px' }}>Application submitted</h2>
          <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.6', margin: '0 0 8px' }}>
            Thank you for signing up as an Iyewo agent. Your application is under review.
          </p>
          <p style={{ color: '#888', fontSize: '14px', margin: 0 }}>
            You will be contacted once your account is approved.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '32px 20px' }}>
      <div style={{ width: '100%', maxWidth: '480px' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ width: '48px', height: '48px', background: '#009396', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
            <span style={{ color: '#F6B219', fontSize: '20px', fontWeight: 700 }}>IH</span>
          </div>
          <h1 style={{ margin: '0 0 4px', fontSize: '22px', fontWeight: 700, color: '#333' }}>Become an Iyewo Agent</h1>
          <p style={{ margin: 0, color: '#888', fontSize: '14px' }}>Fill in your details to apply. We will review and get back to you.</p>
        </div>

        <div style={{ background: 'white', borderRadius: '12px', padding: '28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
          <form onSubmit={handleSubmit}>

            {/* Personal details */}
            <p style={{ fontSize: '11px', fontWeight: 700, color: '#009396', textTransform: 'uppercase', letterSpacing: '0.6px', margin: '0 0 16px' }}>Personal Details</p>

            {field(<>
              {label('Full name', true)}
              <input style={inp} type="text" placeholder="Adunola Okonkwo"
                value={form.full_name} onChange={e => set('full_name', e.target.value)} />
            </>)}

            {field(<>
              {label('Email address', true)}
              <input style={inp} type="email" placeholder="you@example.com"
                value={form.email} onChange={e => set('email', e.target.value)} />
            </>)}

            {field(<>
              {label('Country', true)}
              <select style={inp} value={form.country} onChange={e => {
                setForm(f => ({
                  ...f,
                  country: e.target.value,
                  bank_name: '', bank_code: '', account_number: '', account_name: '', sort_code_iban: '',
                }));
              }}>
                {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </>)}

            {field(<>
              {label('Phone number', true)}
              {isNigeria ? (
                <div style={{ display: 'flex', border: '1px solid #dee2e6', borderRadius: '6px', overflow: 'hidden' }}>
                  <span style={{ padding: '10px 12px', background: '#f8f9fa', borderRight: '1px solid #dee2e6', fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>+234</span>
                  <input style={{ ...inp, border: 'none', borderRadius: 0 }} type="tel" placeholder="080 0000 0000"
                    value={form.phone} onChange={e => set('phone', e.target.value)} />
                </div>
              ) : (
                <input style={inp} type="tel" placeholder="Enter your phone number"
                  value={form.phone} onChange={e => set('phone', e.target.value)} />
              )}
            </>)}

            {/* Bank details */}
            <p style={{ fontSize: '11px', fontWeight: 700, color: '#009396', textTransform: 'uppercase', letterSpacing: '0.6px', margin: '24px 0 16px' }}>Bank Details</p>
            <p style={{ fontSize: '13px', color: '#888', margin: '-8px 0 16px' }}>Used for commission payouts. Ensure these are correct.</p>

            {isNigeria ? (<>
              {field(<>
                {label('Bank name', true)}
                <select style={inp} value={form.bank_code} disabled={banksLoading} onChange={e => {
                  const selected = banks.find(b => b.code === e.target.value);
                  setForm(f => ({ ...f, bank_name: selected?.name ?? '', bank_code: e.target.value }));
                }}>
                  <option value="">{banksLoading ? 'Loading banks...' : 'Select bank'}</option>
                  {banks.map(b => <option key={b.code} value={b.code}>{b.name}</option>)}
                </select>
              </>)}

              {field(<>
                {label('Account number', true)}
                <input style={inp} type="text" inputMode="numeric" maxLength={10} placeholder="0123456789"
                  value={form.account_number} onChange={e => set('account_number', e.target.value.replace(/\D/g, ''))} />
              </>)}

              {field(<>
                {label('Account name', true)}
                <input style={inp} type="text" placeholder="As it appears on your bank statement"
                  value={form.account_name} onChange={e => set('account_name', e.target.value)} />
              </>)}
            </>) : (<>
              {field(<>
                {label('Bank name', true)}
                <input style={inp} type="text" placeholder="e.g. Barclays, HSBC, Chase"
                  value={form.bank_name} onChange={e => set('bank_name', e.target.value)} />
              </>)}

              {field(<>
                {label('Account number', true)}
                <input style={inp} type="text" placeholder="Enter your account number"
                  value={form.account_number} onChange={e => set('account_number', e.target.value)} />
              </>)}

              {field(<>
                {label('Account holder name', true)}
                <input style={inp} type="text" placeholder="As it appears on your bank account"
                  value={form.account_name} onChange={e => set('account_name', e.target.value)} />
              </>)}

              {field(<>
                {label('Sort code / IBAN', false)}
                <input style={inp} type="text" placeholder="e.g. 20-00-00 or GB29 NWBK..."
                  value={form.sort_code_iban} onChange={e => set('sort_code_iban', e.target.value)} />
              </>)}
            </>)}

            {/* Service lines */}
            <p style={{ fontSize: '11px', fontWeight: 700, color: '#009396', textTransform: 'uppercase', letterSpacing: '0.6px', margin: '24px 0 16px' }}>Service Lines</p>

            {field(<>
              {label('Which products will you be working on?', true)}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '4px' }}>
                {SERVICE_LINES.map(sl => (
                  <label key={sl.value} style={{ display: sl.value === 'market_health' ? 'none' : 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', padding: '10px 12px', border: `1px solid ${form.service_lines.includes(sl.value) ? '#009396' : '#dee2e6'}`, borderRadius: '6px', background: form.service_lines.includes(sl.value) ? '#e0f5f5' : 'white', transition: 'all 0.15s' }}>
                    <input type="checkbox" checked={form.service_lines.includes(sl.value)} onChange={() => toggleServiceLine(sl.value)}
                      style={{ width: '16px', height: '16px', accentColor: '#009396' }} />
                    <span style={{ fontSize: '14px', fontWeight: form.service_lines.includes(sl.value) ? 600 : 400, color: form.service_lines.includes(sl.value) ? '#006e70' : '#333' }}>
                      {sl.label}
                    </span>
                  </label>
                ))}
              </div>
            </>)}

            {error && (
              <div style={{ background: '#fff5f5', border: '1px solid #f5c6cb', borderRadius: '6px', padding: '10px 14px', fontSize: '13px', color: '#dc3545', marginBottom: '16px' }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '12px', background: loading ? '#ccc' : '#009396',
              color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px',
              fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', transition: 'background 0.2s',
            }}>
              {loading ? 'Submitting...' : 'Submit application'}
            </button>

          </form>
        </div>

        <p style={{ textAlign: 'center', fontSize: '12px', color: '#aaa', marginTop: '20px' }}>
          Already an agent? Contact your supervisor for login access.
        </p>
      </div>
    </div>
  );
}
